import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { BuyerCouponProducts } from '~/api/model';

// Response 타입 (Zod Model 재사용 — OAISchema 금지, api-typegen §0)
type BuyerCouponProductResponse = BuyerCouponProducts;

export type GetBuyerCouponProductsParams = {
  buyerCouponId: number;
  sortType?: string;
  size?: number;
  searchAfter?: string[];
};

export interface BuyerCouponProductsDataSource {
  // Query
  getBuyerCouponProducts(
    params: GetBuyerCouponProductsParams,
  ): Promise<BuyerCouponProductResponse>;
}

export class BuyerCouponProductsDataSourceImpl
  implements BuyerCouponProductsDataSource
{
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getBuyerCouponProducts(params: GetBuyerCouponProductsParams) {
    return this.client.request<BuyerCouponProductResponse>({
      url: '/api/market-place/v1/buyer-coupon/products',
      method: 'get',
      params: { ...params },
    });
  }
}

export const buyerCouponProductsDataSource =
  new BuyerCouponProductsDataSourceImpl();
